module.exports = __webpack_public_path__ + "img/spring.be5030ca.webp";